import { useTranslation } from "@repo/i18n";
import { css } from "@repo/styled-system/css";
import { BOOKING_VIEWS, type BookingView } from "./searchParams";

/**
 * The view switcher. Switching view only rewrites the `?view=` param — the shared query layer means
 * the SAME dataset is re-presented, never refetched differently and never mutated (spec "Views").
 */
export function ViewSwitcher({
  view,
  onChange,
}: {
  view: BookingView;
  onChange: (v: BookingView) => void;
}) {
  const { t } = useTranslation();
  return (
    <div
      role="tablist"
      aria-label={t("bookings.views.label")}
      className={css({ display: "flex", gap: "1", flexWrap: "wrap" })}
    >
      {BOOKING_VIEWS.map((v) => (
        <button
          key={v}
          type="button"
          role="tab"
          aria-selected={v === view}
          onClick={() => onChange(v)}
          className={css({
            px: "3",
            py: "1.5",
            rounded: "md",
            fontSize: "sm",
            fontWeight: v === view ? "semibold" : "normal",
            borderWidth: "1px",
            borderColor: v === view ? "colorPalette.default" : "border.default",
            bg: v === view ? "bg.muted" : "transparent",
          })}
        >
          {t(`bookings.views.${v}`)}
        </button>
      ))}
    </div>
  );
}
